export const namespace = 'externalLiquidityStats'
